import { buildAdebifyFilterKeySet, DEFAULT_ADEBIFY_AXIS } from 'domain/adebify/screenFilterKeys';

// Filter visibility rules for the LTV分析 (Adebify LTV Detail) screen.
//
// Source of truth: adebify/docs/要件.md 付録E-2 and 要件 14-2.
//
// Product axis (購入商品軸 / 広告対象商品軸) controls table dimensions and
// metric visibility only — it does not hide traffic filters.
const getAdebifyLtvDetailFilterKeys = (currentTab, filterContext = {}) => {
  const axis =
    filterContext.adebifyLtvDetailAxis || DEFAULT_ADEBIFY_AXIS;

  return buildAdebifyFilterKeySet({ axis, currentTab });
};

export default getAdebifyLtvDetailFilterKeys;
